import { useEffect, useState } from 'react';
import Script from 'next/script';

import { useGlobalInfo } from '@/utils/hooks/context/useGlobalInfo';
// Hooks
import useUser from '@/utils/hooks/swr/useUser';
import useTranslation from '@/utils/hooks/translation/useTranslation';

export function AdobeExpress() {
    const { user } = useUser();
    const { globalInfo, dispatch } = useGlobalInfo();
    const { lang } = useTranslation();

    const [isLoaded, setIsLoaded] = useState(false);

    async function initializeAdobeExpress() {
        if (isLoaded && !globalInfo?.adobeExpress) {
            const ccEverywhere = await window.CCEverywhere.initialize(
                {
                    clientId: process.env.NEXT_PUBLIC_ADOBE_EXPRESS_CLIENT_ID,
                    appName: 'Iconosquare'
                },
                { locale: `${lang}_${lang.toUpperCase()}` }
            );
            dispatch({
                type: 'INIT_ADOBE_EXPRESS',
                payload: ccEverywhere
            });
        }
    }

    useEffect(() => {
        initializeAdobeExpress();
    }, [isLoaded]);

    if (!user) return null;

    return (
        <Script
            src="https://sdk.cc-embed.adobe.com/v3/CCEverywhere.js"
            onLoad={() => setIsLoaded(true)}
        />
    );
}
